import React, { useState } from 'react';
import bemCn from 'bem-cn';
import { getStarClassTuple } from './fill-star';
import './style.scss';

const b = bemCn('sniff-stars');

const SniffStars = ({ readOnly = false, onHover, starClassName, className, onChange, initialValue = 0 }) => {
    const [maxSelected, setMaxSelected] = useState(initialValue);
    const [lastSelected, setLastSelected] = useState(initialValue);

    function handleChangeStar(index) {
        setLastSelected(index);
        setMaxSelected(index);

        if (typeof onChange === 'function') {
            onChange(index);
        }
    }

    function updateMaxSelected(number) {
        setMaxSelected(number);

        if (typeof onHover === 'function') {
            onHover(number);
        }
    }

    return (
        <div className={b.mix(className)}>
            {[1, 2, 3, 4, 5].map((number) => {
                const [currStarClassName, isActive] = getStarClassTuple(number, maxSelected);

                const divProps = {
                    className: b('star', { [currStarClassName]: isActive, 'read-only': Boolean(readOnly) }).mix(starClassName),
                };

                if (!readOnly) {
                    divProps.onMouseOut = () => updateMaxSelected(lastSelected);
                    divProps.onMouseOver = () => updateMaxSelected(number);
                    divProps.onClick = () => handleChangeStar(number);
                }

                return (
                    <div key={number} {...divProps}>
                        <div className={b('item', { fill: true }).mix(`${starClassName}__item`)}></div>
                        <div className={b('item', { empty: true }).mix(`${starClassName}__item`)}></div>
                    </div>
                );
            })}
        </div>
    );
};

export default SniffStars;
